import React from 'react'

import {
  Box,
  Dialog,
  IconButton,
  Paper,
  Typography,
  styled,
} from '@mui/material'

import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import ClearIcon from '@mui/icons-material/Clear'
import { useTranslation } from 'react-i18next'
import FooterBtn from './FooterBtn'

const FooterBtnWrapper = styled('div')({
  width: '100%',
  position: 'absolute',
  bottom: 0,
  backgroundColor: '#fff',
  zIndex: '10',
  boxShadow: '2px 0px 8px rgba(0, 0, 0, 0.08)',
})

export default function CustomWindow({
  title,
  open,
  handleClose,
  variant,
  footerBtn,
  noPadding = false,
  icon = 'back',
  handleClick,
  ...props
}: {
  title: string
  open: boolean
  handleClose: () => void
  variant?: string
  footerBtn?: boolean
  noPadding?: boolean
  icon?: string
  handleClick?: () => void
  children: React.ReactNode
}) {
  const { t } = useTranslation()

  return (
    <Dialog fullScreen open={open}>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          padding: (theme) => theme.spacing(1),
          backgroundColor: '#fff',
          boxShadow: '0px 0px 2px rgba(0, 0, 0, 0.08)',
          position: 'fixed',
          width: '100%',
          zIndex: '10',
          top: 0,
        }}
      >
        <Box display="flex" alignItems="center">
          <IconButton
            sx={{
              '& svg': {
                color: (theme) => theme.palette.text.primary,
              },
            }}
            size="small"
            onClick={handleClose}
          >
            {icon === 'back' ? <ArrowBackIcon /> : <ClearIcon />}
          </IconButton>
          <Typography
            variant="h1"
            sx={{ marginLeft: (theme) => theme.spacing(3) }}
          >
            {title}
          </Typography>
        </Box>
      </Box>

      <Paper
        sx={{
          padding: (theme) => theme.spacing(7, 2, 8),
          justifyContent: 'center',
          alignItems: 'center',
          display: 'flex',
          flexDirection: 'column',
          height: '100%',
          flexGrow: 1,
          ...(noPadding && {
            paddingLeft: 0,
            paddingRight: 0,
          }),
        }}
        elevation={0}
      >
        {props.children}
      </Paper>
      {footerBtn && (
        <FooterBtnWrapper>
          <FooterBtn
            title={t('footer.complete')}
            {...(handleClick && {
              handleClick,
            })}
          />
        </FooterBtnWrapper>
      )}
    </Dialog>
  )
}
